export const CUSTOMER_TYPES = [
    { value: 'customer', label: 'Customer (Sell To)' },
    { value: 'client', label: 'Client (Buy From)' },
]